import { RootState } from 'global/state';

export const getNotificationCount = (state: RootState) => (
    state.notificationState.count.unread
);

export const getNotificationList = (state: RootState, limit: number|undefined) => (
    state.notificationState.list.slice(0, limit)
);
